'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var PIPO_PATH_GET_API_KEY = exports.PIPO_PATH_GET_API_KEY = '/ajax/action_user/set_api_key';
var PIPO_PATH_GET_GET_BY_ID = exports.PIPO_PATH_GET_GET_BY_ID = '/action_shop/get_by_id';
var PIPO_PATH_LOGIN = exports.PIPO_PATH_LOGIN = '/ajax/action_user/login';
var PIPO_PATH_GET_INPUT_GROUPS_BY_PAYMENT_IN_ID = exports.PIPO_PATH_GET_INPUT_GROUPS_BY_PAYMENT_IN_ID = '/ajax/action_api/get_input_groups_by_payment_in_id';
var PIPO_PATH_GET_DETAIL_PAYIN = exports.PIPO_PATH_GET_DETAIL_PAYIN = '/ajax/action_account/get_detail_payin';
var PIPO_PATH_PROCESS_INPUT = exports.PIPO_PATH_PROCESS_INPUT = '/api/process_input';


//////////////////
// WEBPACK FOOTER
// ./src/api/pipo/constants.js
// module id = 1593
// module chunks = 0